import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private notificationSubject = new Subject<{
    message: string;
    type: string;
    title: string;
  } | null>();

  notification$ = this.notificationSubject.asObservable();

  UMUIMSelectionCoverageNotificationFlag: boolean = false;
  UMUIMOutstandingNotificationFlag: boolean = false;

  PIPSelectionCoverageNotificationFlag: boolean = false;
  PIPOutstandingNotificationFlag: boolean = false;

  constructor() {}

  showNotification(message: string, type: string, title: string = '') {
    this.notificationSubject.next({ message, type, title });
  }

  clearNotification() {
    this.notificationSubject.next(null);
  }
}
